import { getAllDeals as getAllDealsAPI, addDeal as addDealAPI, deleteDeal as deleteDealAPI, updateDeal as updateDealAPI } from '../api/deals';

export const GET_ALL_DEALS_SUCCESS = 'GET_ALL_DEALS_SUCCESS';
export const GET_ALL_DEALS_FAILURE = 'GET_ALL_DEALS_FAILURE';

export const ADD_DEAL_SUCCESS = 'ADD_DEAL_SUCCESS';
export const ADD_DEAL_FAILURE = 'ADD_DEAL_FAILURE';

export const UPDATE_DEAL_REQUEST = 'UPDATE_DEAL_REQUEST';
export const UPDATE_DEAL_SUCCESS = 'UPDATE_DEAL_SUCCESS';
export const UPDATE_DEAL_FAILURE = 'UPDATE_DEAL_FAILURE';

export const DELETE_DEAL_REQUEST = 'DELETE_DEAL_REQUEST';
export const DELETE_DEAL_SUCCESS = 'DELETE_DEAL_SUCCESS';
export const DELETE_DEAL_FAILURE = 'DELETE_DEAL_FAILURE';

export const getAllDeals = (options = {}) => async (dispatch, getState) => {
  try {
    const allDeals = await getAllDealsAPI(options);
    return dispatch({
      type: GET_ALL_DEALS_SUCCESS,
      deals: allDeals,
      ...options,
    });
  } catch (error) {
    return dispatch({
      type: GET_ALL_DEALS_FAILURE,
      error,
    });
  }
};

export const addDeal = (data = {}) => async (dispatch, getState) => {
  try {
    const newDeal = await addDealAPI(data);
    window.__ADD_EVENT__('Deals - Add Deal', { deal: newDeal });
    return dispatch({
      type: ADD_DEAL_SUCCESS,
      deal: newDeal,
    });
  } catch (error) {
    return dispatch({
      type: ADD_DEAL_FAILURE,
      error,
    });
  }
};

export const updateDeal = (deal, updates) => async (dispatch, getState) => {
  dispatch({
    type: UPDATE_DEAL_REQUEST,
    deal,
    updates,
  });
  try {
    const updatedDeal = await updateDealAPI(deal, updates);
    window.__ADD_EVENT__('Deals - Update Deal', { deal: updatedDeal });
    return dispatch({
      type: UPDATE_DEAL_SUCCESS,
      deal: updatedDeal,
    });
  } catch (error) {
    return dispatch({
      type: UPDATE_DEAL_FAILURE,
      error,
    });
  }
};

export const deleteDeal = (deal) => async (dispatch, getState) => {
  dispatch({
    type: DELETE_DEAL_REQUEST,
    deal,
  });
  try {
    await deleteDealAPI(deal);
    window.__ADD_EVENT__('Deals - Delete Deal', { deal });
    return dispatch({
      type: DELETE_DEAL_SUCCESS,
      deal,
    });
  } catch (error) {
    return dispatch({
      type: DELETE_DEAL_FAILURE,
      error,
      deal,
    });
  }
};
